module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo-1-657a76d33e97d0f041c17c954eddce8e.png";